const isContactLensesOrderLineItem = (lineItem)=>'type' in lineItem && lineItem.type === 'CONTACT_LENSES'
;
const isGlassesBundleOrderLineItem = (lineItem)=>'type' in lineItem && lineItem.type === 'GLASSES_BUNDLE'
;

export { isContactLensesOrderLineItem, isGlassesBundleOrderLineItem };
//# sourceMappingURL=line-items.js.map
